import {Redirect, Route} from 'react-router-dom';
import PropTypes from "prop-types";
import {useKeycloak} from '@react-keycloak/web'
import logo from "../../assets/images/logo.png";

const External = ({component: Component, ...rest}) => {
    const {keycloak, initialized} = useKeycloak();

    let isTeacher;
    let redirectRoute = null;
    if (keycloak && keycloak.authenticated) {
        isTeacher = keycloak.realmAccess.roles.includes('teacher')
    }
    if (keycloak.authenticated) {
        redirectRoute = isTeacher ? "/teacher/home" : "/student/start-live-class";
    }

    return (
        <Route {...rest} render={matchProps => (
            redirectRoute ?
                <Redirect push to={redirectRoute}/> :
                <div className={"layout ExternalLayout"}>
                    <img src={logo} className={"p-3 absolute buddingAILogo"} alt="budding-ai-logo" draggable={false}/>
                    <div className="content">
                        <Component {...matchProps} />
                    </div>
                </div>
        )}/>
    )
};

export default External;

External.propTypes = {
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
}
